//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React, { useState, useEffect } from 'react';
import FocusTrap from 'focus-trap-react';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Modal } from '@cmp/common';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { AccountApprovedDogImage, ExternalLinkIcon } from '@cmp/images';
// API -------------------------------------------------------------------------
import { getProviderQRStatus } from '@api/endpoints/get/providers';
// Helpers ---------------------------------------------------------------------
import { handleAfterWelcomeModalHelper } from '@helpers/account';
import { useTranslation } from 'react-i18next';

//------------------------------------------------------------------------------
// React Component -----------------------------------------------------------------

const AfterWelcome = (props) => {
  const { history, location } = props;
  const { t } = useTranslation();
  const [hideModal, setHideModal] = useState(false);
  const [modalSubheader, setModalSubheader] = useState('');
  const [modalSubheaderSecondary, setModalSubheaderSecondary] = useState('');

  useEffect(() => {
    const fetchProviderQrStatus = () => {
      let loggedinVet = JSON.parse(localStorage.getItem('colgate_user'));

      // Make a call to Quick reco`s /registered_users endpoint to check HVS/MHS approved vet account isRegistered.
      return getProviderQRStatus(loggedinVet.data.practiceNumber)
        .then(({ data }) => {
          const { status, isRegistered } = data;

          if (status === 200 && isRegistered == true) {
            setModalSubheader(t('afterWelcome_modalSubheader_QR_approved'));
            setModalSubheaderSecondary(
              t('afterWelcome_modalSubheaderSecondary_QR_approved')
            );
          }
        })
        .catch((error) => {
          // On error, or Promise rejection - set the modal to QR not approved
          setModalSubheader(t('afterWelcome_modalSubheader_QR_not_approved'));
          setModalSubheaderSecondary(
            t('afterWelcome_modalSubheaderSecondary_QR_not_approved')
          );
        });
    };
    fetchProviderQrStatus();
  }, []);

  const handleModalClose = () => {
    history.push({
      pathname: '/',
      state: { from: location, modal: false },
    });
  };

  const handleRemindMeLater = () => {
    handleAfterWelcomeModalHelper({ remindMeLater: true });
    handleModalClose();
  };

  const handleDontShowAgain = () => {
    handleAfterWelcomeModalHelper({ dontShowAgain: true });
    handleModalClose();
  };

  const SectionButtons = () => {
    const handleQuickRecoLaunch = () => {
      window.open(import.meta.env.VITE_QUICK_RECO_URL, '_blank');
      handleModalClose();
    };

    return (
      <div className={styles.CtaContainer}>
        <button
          className={styles.ButtonRecommendingNow}
          onClick={handleModalClose}
        >
          {t('afterWelcome_ctaButtonLabelPrimary')}
        </button>
        <p>{t('or_separator')}</p>
        <button
          className={styles.ButtonQuickRecoLaunch}
          onClick={handleQuickRecoLaunch}
        >
          <span className={styles.ExternalLinkIcon}>
            <ExternalLinkIcon />
          </span>
          {t('afterWelcome_ctaButtonLabelSecondary')}
        </button>
        <p className={styles.SubheaderText}>{modalSubheaderSecondary}</p>
      </div>
    );
  };

  const SectionOptions = () => {
    return (
      <div className={styles.SectionOptionsContainer}>
        <button
          className={styles.SectionOptionsRemindLaterOrDontShowAgain}
          onClick={handleDontShowAgain}
        >
          {t('afterWelcome_disableModalDisplaying')}
        </button>
        <span className={styles.SectionOptionsSeparatorText}>
          {t('or_separator')}
        </span>
        <button
          className={styles.SectionOptionsRemindLaterOrDontShowAgain}
          onClick={handleRemindMeLater}
        >
          {t('afterWelcome_disableModalRemindLater')}
        </button>
      </div>
    );
  };

  return (
    <FocusTrap>
      <Modal.Base onClose={handleModalClose} to={'/'} {...props}>
        <div className={styles.AfterWelcomeContainer}>
          <div>
            <div>
              <AccountApprovedDogImage
                className={styles.AccountApprovedDogImage}
              />
            </div>
            <div className={styles.AfterWelcomeContentContainer}>
              <h2 className={styles.AfterWelcomeHeader}>
                {t('afterWelcome_modalHeader')}
              </h2>
              <p className={styles.AfterWelcomeSubheader}>{modalSubheader}</p>

              <SectionButtons />
              <SectionOptions />
            </div>
          </div>
        </div>
      </Modal.Base>
    </FocusTrap>
  );
};

//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default AfterWelcome;
